var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask"},[_c('img',{attrs:{"src":require("./img/loading.gif")}}),_c('span',{staticClass:"message"},[_vm._t("default",[_vm._v("数据请求中...")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }